import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchTimeSheet = ({
  accountId,
  branchIds,
  from,
  to,
  employeeIds,
  projectIds,
  filters,
  withFields,
  warnings = true,
  withJobs = false,
  withPto = false,
  withLeave = false,
  withExternalEmployees = false,
  withTimesheetFields = false,
  invoiceStatus
}) => {
  return get(`/accounts/${accountId}/jobs`, {
    branches: branchIds,
    from,
    to,
    employeeIds,
    projectIds,
    filters,
    warnings,
    withJobs,
    withPto,
    withLeave,
    withFields,
    withExternalEmployees,
    withTimesheetFields,
    invoiceStatus
  });
};

export const createJob = ({ accountId, ...params }) => post(`/accounts/${accountId}/jobs`, params);

export const updateJob = ({ accountId, jobId, ...params }) => patch(`/accounts/${accountId}/jobs/${jobId}`, params);

export const updateJobPayrollField = ({ accountId, jobId, payrollFieldId, value }) =>
  patch(`/accounts/${accountId}/jobs/${jobId}/payroll/fields/${payrollFieldId}`, { value });

export const deleteJob = ({ accountId, jobId }) => httpDelete(`/accounts/${accountId}/jobs/${jobId}`);
